"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_css_grid_1 = require("styled-css-grid");
var styled_components_1 = __importDefault(require("styled-components"));
var reactjs_popup_1 = __importDefault(require("reactjs-popup"));
var _HourCell = styled_components_1.default(styled_css_grid_1.Cell)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 12px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  border: 1px solid #dddddd63;\n  /*background: #feedde;*/\n  line-height: 1;\n  height: 50%;\n  border-radius: 4px;\n  width: 70%;\n  transform: translate(15%, 40%);\n  &:hover {\n    border: 1px dashed;\n  }\n"], ["\n  font-size: 12px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  border: 1px solid #dddddd63;\n  /*background: #feedde;*/\n  line-height: 1;\n  height: 50%;\n  border-radius: 4px;\n  width: 70%;\n  transform: translate(15%, 40%);\n  &:hover {\n    border: 1px dashed;\n  }\n"])));
var contentStyle = {
    width: "unset",
    background: "#000000c9",
    color: '#f7f7f7',
    border: "0px solid"
};
var HourCell = function (_a) {
    var data = _a.data, scale = _a.scale, height = _a.height, popup = _a.popup;
    var CustomPopup = popup;
    return (react_1.default.createElement("div", { role: "hour-cell" },
        react_1.default.createElement(reactjs_popup_1.default, { trigger: function (open) { return (react_1.default.createElement(_HourCell, { center: true, middle: true, height: height, style: { background: scale(data.value) } })); }, closeOnDocumentClick: true, on: ['hover', 'focus', 'click'], contentStyle: contentStyle, position: ['top center', 'bottom right', 'bottom left'], keepTooltipInside: ".tooltipBoundary", arrow: false },
            react_1.default.createElement("span", null, popup ? react_1.default.createElement(CustomPopup, { data: data }) : data.value))));
};
exports.default = HourCell;
var templateObject_1;
